// extracted by mini-css-extract-plugin
module.exports = {"vertCenter":"_404-module--vert-center--19BDJ"};